"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var styled_components_1 = require("styled-components");

var SquaredButton_styled_1 = require("./SquaredButton.styled");

var atoms_icon_1 = __importDefault(require("@lettucegrow/atoms.icon"));

var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");

var SquaredButton = function SquaredButton(_ref) {
  var id = _ref.id,
      type = _ref.type,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      label = _ref.label,
      modifiers = _ref.modifiers,
      as = _ref.as,
      target = _ref.target,
      className = _ref.className,
      dataNw = _ref.dataNw,
      ariaLabel = _ref.ariaLabel,
      ariaSelected = _ref.ariaSelected,
      children = _ref.children;

  var _a;

  var accessibilityProps = Object.assign(Object.assign({}, ariaLabel ? {
    'aria-label': ariaLabel
  } : {}), ariaSelected ? {
    'aria-selected': ariaSelected
  } : {});
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: atoms_utils_theme_1.theme
  }, react_1.default.createElement(SquaredButton_styled_1.SquaredButtonStyled, Object.assign({
    id: id,
    type: type,
    disabled: disabled,
    onClick: onClick,
    modifiers: modifiers,
    as: as,
    target: target,
    className: className,
    "data-nw": dataNw
  }, accessibilityProps), ((_a = modifiers === null || modifiers === void 0 ? void 0 : modifiers.includes) === null || _a === void 0 ? void 0 : _a.call(modifiers, 'loading')) ? react_1.default.createElement(atoms_icon_1.default, null, react_1.default.createElement("svg", {
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
    width: '65.642',
    height: '66.021',
    viewBox: '0 0 65.642 66.021'
  }, react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: 'a'
  }, react_1.default.createElement("path", {
    d: 'M0,0H65.642V66.021H0Z',
    transform: 'translate(0 0)',
    fill: 'none'
  }))), react_1.default.createElement("g", {
    transform: 'translate(0 0)'
  }, react_1.default.createElement("path", {
    d: 'M0,0H65.642V66.021H0Z',
    transform: 'translate(0 0)',
    fill: 'none'
  }), react_1.default.createElement("g", {
    clipPath: 'url(#a)'
  }, react_1.default.createElement("path", {
    d: 'M32.819,66.021A35.857,35.857,0,0,1,4.974,52.8l0,0-.015-.016-.02-.021a.536.536,0,0,1-.119-.332.013.013,0,0,0,0-.007v-.009a.015.015,0,0,0,0-.008.536.536,0,0,1,.119-.332l.019-.021.016-.017,0-.005a36.361,36.361,0,0,1,4.51-4.6.218.218,0,0,0,.066-.25.229.229,0,0,0-.211-.153.236.236,0,0,0-.079.014,36.206,36.206,0,0,1-6.3,1.616.523.523,0,0,1-.089.008A.561.561,0,0,1,2.6,48.59a.017.017,0,0,1-.006-.008.014.014,0,0,0-.005-.007.546.546,0,0,1-.226-.263A35.962,35.962,0,0,1,30.25.008.561.561,0,0,1,30.345,0a.548.548,0,0,1,.5.352A36.3,36.3,0,0,1,32.6,6.61a.228.228,0,0,0,.447,0A36.3,36.3,0,0,1,34.793.352.536.536,0,0,1,35.3,0a.617.617,0,0,1,.094.007,35.96,35.96,0,0,1,27.887,48.3.546.546,0,0,1-.226.263.013.013,0,0,0-.006.007.015.015,0,0,1-.006.008.57.57,0,0,1-.274.074.518.518,0,0,1-.088-.008,36.233,36.233,0,0,1-6.3-1.616.241.241,0,0,0-.081-.014.228.228,0,0,0-.211.153.216.216,0,0,0,.067.247,36.371,36.371,0,0,1,4.514,4.607l.005.005.017.019.017.019a.532.532,0,0,1,.12.332.013.013,0,0,0,0,.007v.009a.015.015,0,0,0,0,.008.532.532,0,0,1-.12.332l-.016.017a.2.2,0,0,0-.019.021.012.012,0,0,1-.005,0A35.876,35.876,0,0,1,32.819,66.021ZM32.59,52.964A10.538,10.538,0,0,0,22.064,63.019a.252.252,0,0,0,.175.25,34.856,34.856,0,0,0,10.58,1.661c.845,0,1.691-.068,2.51-.133a.237.237,0,0,0,.22-.228,13.333,13.333,0,0,1,7.373-11.3.159.159,0,0,0,.086-.181.151.151,0,0,0-.152-.119Zm16.238,0A12.24,12.24,0,0,0,36.653,64.423a.245.245,0,0,0,.067.185.254.254,0,0,0,.184.081l.029,0A34.821,34.821,0,0,0,58.476,53.627a.388.388,0,0,0,.068-.424.393.393,0,0,0-.364-.239Zm-41.365,0a.393.393,0,0,0-.364.24.387.387,0,0,0,.069.423A34.98,34.98,0,0,0,20.7,62.737a.239.239,0,0,0,.083.015.246.246,0,0,0,.242-.227,11.592,11.592,0,0,1,6.113-9.264.159.159,0,0,0,.082-.181.151.151,0,0,0-.151-.117ZM36.9,40.149a.253.253,0,0,0-.184.081.245.245,0,0,0-.067.185A12.242,12.242,0,0,0,48.828,51.872h9.353a.393.393,0,0,0,.364-.239.387.387,0,0,0-.068-.423A34.821,34.821,0,0,0,36.933,40.151Zm-4.085-.241a34.884,34.884,0,0,0-10.58,1.66.255.255,0,0,0-.175.251A10.54,10.54,0,0,0,32.59,51.872H42.857a.151.151,0,0,0,.152-.118.159.159,0,0,0-.086-.181,13.336,13.336,0,0,1-7.374-11.3.238.238,0,0,0-.219-.229l-.033,0C34.489,39.974,33.652,39.908,32.819,39.908ZM20.783,42.085a.239.239,0,0,0-.083.015A34.987,34.987,0,0,0,7.168,51.21a.387.387,0,0,0-.068.423.393.393,0,0,0,.364.239H27.069a.151.151,0,0,0,.151-.116.157.157,0,0,0-.082-.181,11.6,11.6,0,0,1-6.114-9.264A.246.246,0,0,0,20.783,42.085ZM51.311,29.516a.162.162,0,0,0-.117.05.157.157,0,0,0-.043.119,11.349,11.349,0,0,1-4.97,9.917.248.248,0,0,0-.107.194.238.238,0,0,0,.086.194,35.014,35.014,0,0,0,14.657,7.166.4.4,0,0,0,.088.01.4.4,0,0,0,.339-.6L51.444,29.6A.15.15,0,0,0,51.311,29.516ZM19.626,32.351a11.992,11.992,0,0,0-3.117.414,12.156,12.156,0,0,0-7.432,5.7l0,0L4.4,46.569a.4.4,0,0,0,.338.6.4.4,0,0,0,.088-.01,34.809,34.809,0,0,0,20.353-13.13.252.252,0,0,0-.087-.373A12.157,12.157,0,0,0,19.626,32.351Zm32.906-3.522a.159.159,0,0,0-.137.08.151.151,0,0,0,0,.155l9.791,16.959a.392.392,0,0,0,.344.2.387.387,0,0,0,.377-.273,34.978,34.978,0,0,0,1.125-16.259.235.235,0,0,0-.233-.2.242.242,0,0,0-.1.023,11.464,11.464,0,0,1-4.9,1.117,11.683,11.683,0,0,1-6.175-1.778A.162.162,0,0,0,52.532,28.828ZM4.159,21.608a.252.252,0,0,0-.233.151A34.825,34.825,0,0,0,2.731,45.946a.388.388,0,0,0,.378.273.393.393,0,0,0,.344-.2l4.685-8.115A12.241,12.241,0,0,0,4.294,21.649.242.242,0,0,0,4.159,21.608ZM32.819,38.816a35.683,35.683,0,0,1,12.616,2.333.164.164,0,0,0,.058.011.149.149,0,0,0,.138-.1.147.147,0,0,0-.049-.168,35.7,35.7,0,0,1-8.327-9.758,35.686,35.686,0,0,1-4.288-12.088.15.15,0,0,0-.3,0,35.692,35.692,0,0,1-4.286,12.085,35.688,35.688,0,0,1-8.329,9.76.147.147,0,0,0-.049.168.149.149,0,0,0,.138.1.164.164,0,0,0,.058-.011A35.687,35.687,0,0,1,32.819,38.816Zm10.6-22.978a.163.163,0,0,0-.118.051.156.156,0,0,0-.042.12,13.184,13.184,0,0,1-6.1,12.036.24.24,0,0,0-.089.3l.025.053c.345.724.7,1.472,1.114,2.185a34.882,34.882,0,0,0,6.729,8.334.253.253,0,0,0,.17.065.248.248,0,0,0,.134-.039,10.513,10.513,0,0,0,3.444-14.141l-5.13-8.89A.151.151,0,0,0,43.416,15.839Zm-17.1,3.287a10.523,10.523,0,0,0-9.117,5.28l0,.006L12.061,33.3a.151.151,0,0,0,0,.154.163.163,0,0,0,.138.081.16.16,0,0,0,.09-.028,13.149,13.149,0,0,1,7.341-2.24,13.449,13.449,0,0,1,6.138,1.506.245.245,0,0,0,.112.027.237.237,0,0,0,.2-.1l.036-.052c.454-.66.922-1.343,1.333-2.054a34.861,34.861,0,0,0,3.852-10,.252.252,0,0,0-.129-.275A10.5,10.5,0,0,0,26.313,19.125ZM12.669,9.677a.248.248,0,0,0-.169.065,34.818,34.818,0,0,0-6.728,8.333c-.41.71-.766,1.455-1.109,2.175l-.031.065a.237.237,0,0,0,.089.3,13.338,13.338,0,0,1,6.1,12.038.157.157,0,0,0,.042.121.162.162,0,0,0,.117.05.152.152,0,0,0,.133-.079l5.142-8.906A10.506,10.506,0,0,0,12.8,9.716.243.243,0,0,0,12.669,9.677Zm31.964,5.467a.161.161,0,0,0-.138.081.151.151,0,0,0,0,.155l5.135,8.894a10.561,10.561,0,0,0,13.963,4.074.256.256,0,0,0,.13-.276,34.89,34.89,0,0,0-3.852-9.994c-.4-.7-.863-1.369-1.308-2.016l-.055-.08a.237.237,0,0,0-.2-.1.245.245,0,0,0-.112.027,13.24,13.24,0,0,1-13.478-.733A.161.161,0,0,0,44.633,15.145ZM35.54,2.445a.388.388,0,0,0-.378.273,34.827,34.827,0,0,0,1.194,24.191.251.251,0,0,0,.232.15.244.244,0,0,0,.134-.04,12.066,12.066,0,0,0,5.385-8.627,12.662,12.662,0,0,0-1.677-7.874L35.884,2.642A.393.393,0,0,0,35.54,2.445Zm-5.439,0a.393.393,0,0,0-.344.2L19.952,19.626a.151.151,0,0,0,0,.155.161.161,0,0,0,.138.081.163.163,0,0,0,.087-.026,11.626,11.626,0,0,1,11.082-.666.248.248,0,0,0,.1.023.241.241,0,0,0,.24-.2A34.988,34.988,0,0,0,30.479,2.718.388.388,0,0,0,30.1,2.445ZM28.474,1.5a.4.4,0,0,0-.087.01,35,35,0,0,0-14.66,7.168.238.238,0,0,0-.086.194.248.248,0,0,0,.107.194,11.592,11.592,0,0,1,4.969,9.924.158.158,0,0,0,.044.118.162.162,0,0,0,.116.049.151.151,0,0,0,.132-.079L28.813,2.1a.4.4,0,0,0-.339-.6Zm8.693,0a.4.4,0,0,0-.34.6l4.678,8.1a12.24,12.24,0,0,0,10.576,6.087,12.125,12.125,0,0,0,5.435-1.276.251.251,0,0,0,.088-.373A34.832,34.832,0,0,0,37.255,1.508.4.4,0,0,0,37.168,1.5Z',
    transform: 'translate(0 0)',
    fill: '#3D714E'
  }))))) : react_1.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: label
    }
  }), children));
};

SquaredButton.defaultProps = {
  id: null,
  type: '',
  disabled: false,
  onClick: null,
  label: '',
  modifiers: null,
  as: '',
  className: '',
  ariaLabel: null,
  ariaSelected: null
};
SquaredButton.propTypes = {
  id: prop_types_1.default.string,
  type: prop_types_1.default.string,
  disabled: prop_types_1.default.bool,
  onClick: prop_types_1.default.func,
  label: prop_types_1.default.string,
  modifiers: prop_types_1.default.any,
  as: prop_types_1.default.string,
  target: prop_types_1.default.string,
  className: prop_types_1.default.string,
  dataNw: prop_types_1.default.string,
  ariaLabel: prop_types_1.default.string,
  ariaSelected: prop_types_1.default.string,
  children: prop_types_1.default.node
};
exports.default = SquaredButton;